module.exports = __webpack_public_path__ + "static/media/View-1-mobile.22c89fc2.webp";